module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_58-ef85c70c81aeb5e6c2d71e02553bb9d7.png";